import React from 'react';
import { Link } from 'react-router-dom';

import { trackDownloadIndividualSamples } from '../../../../analytics';

import { Button } from '../../../../components/general';

import { ZIP_URL } from '../../../../constants';
import { getPluralPhrase } from '../../../../utils';

import { UploadStage } from '../../components/types';

const getPeopleText = (props: {
  stage: UploadStage;
  peopleCount: number;
  isPublic: boolean;
  isSample: boolean;
  handleUploadMore: (
    e: React.MouseEvent<HTMLElement>,
    position: string,
  ) => void;
}) => {
  const { stage, peopleCount, isPublic, isSample, handleUploadMore } = props;

  const uploadInfoPoints = [
    'One image per person (you can add more later)',
    'No hats, sunglasses or masks',
    'Should only include 1 person on the photo',
    'Should be taken as close as possible to include head and shoulders only',
    'Face should be clearly shown and not blurry',
    'Use high resolution image with good lighting',
    'Your images are in JPEG, JPG, PNG, BMP or GIF format',
  ];

  const summaryInfoPoints = [
    "Toggle the 'Details' switch to see each person's email address, Instagram, and custom field (if applicable)",
    'Click on the person to update their details or upload more photos',
    "Move your cursor over a person and click the 'X' button to delete it",
    "Click 'Check-In More People' to add new people at any time",
  ];

  let subheading = isSample ? (
    <>
      <b>
        Use the assets below by clicking on all the people to load them into
        your project.
      </b>
      <br />
      Our AI will then create personal highlight reels for the identified
      people.
    </>
  ) : (
    <>
      <b>Tell our AI who to look for in your clips.</b>
      <br />
      Check-in people by uploading close-up images of their face. Our AI will
      then create personal highlight reels for the identified people.
      {stage === 'to-upload' && !isPublic && (
        <div className="mt-3 italic">
          Not sure what to upload?{' '}
          <Link
            to={ZIP_URL.FIFA_FACES_ZIP}
            onClick={() => trackDownloadIndividualSamples('people')}
          >
            Try our samples
          </Link>
        </div>
      )}
    </>
  );

  // to upload or uploading view
  if (stage !== 'summary') return { subheading, infoPoints: uploadInfoPoints };

  // people are uploaded
  return {
    subheading: (
      <>
        {getPluralPhrase(peopleCount, 'person')} currently checked in.{' '}
        {!isSample && (
          <Button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              handleUploadMore(e, 'Top link')
            }
            variant="link"
          >
            Check-in more people
          </Button>
        )}
      </>
    ),
    infoPoints: summaryInfoPoints,
  };
};

export default getPeopleText;
